import { useState, useEffect } from 'react';
import { ResolvedEntitlementFeaturesItem } from 'api/models';
import useUserAccountState from 'hooks/useUserAccountState';
import { useListSubscriptions } from 'api/frontend';

export function checkSubscriptionFeature(
  featureName: ResolvedEntitlementFeaturesItem,
) {
  const { currentOrganization } = useUserAccountState();
  const [isFeaturePresent, setIsFeaturePresent] = useState<boolean>(false);
  const { account } = useUserAccountState();
  const { data: subscriptionsData, isLoading } = useListSubscriptions(
    currentOrganization?.slug || '',
    undefined,
    {
      request: { headers: { Authorization: `Bearer ${account.token}` } },
      swr: {
        enabled: !!currentOrganization?.slug,
      },
    },
  );

  useEffect(() => {
    if (
      (subscriptionsData?.total_entitlement.features || []).includes(
        featureName,
      )
    ) {
      setIsFeaturePresent(true);
    } else {
      setIsFeaturePresent(false);
    }
  }, [subscriptionsData]);

  return { isFeaturePresent, isLoading };
}
